import { BCDataGrid } from '@bimser/components';
import React from 'react';
import { ProjectPlatform } from '../../workflow/entities/IWorkflowItem';
import {
	geteBAProcessesDetailsPromise,
	getProcessesDetailsPromise
} from '../sagas/widgets/ProcessDetailsManager';
import { DMListView } from '@bimser/common';

const useProcessDataSource = (
	selectedProcess,
	category,
	bcDataGridRef: React.MutableRefObject<BCDataGrid.Entities.BCDataGridRef>
) => {
	const [structure, setStructure] = React.useState([]);
	const resetScrollRef = React.useRef(false);
	const previousProcessId = DMListView.usePrevious(selectedProcess?.id);

	React.useEffect(() => {
		resetScrollRef.current = true;
	}, [selectedProcess?.id]);

	const dataSource = React.useMemo(() => {
		return new BCDataGrid.Components.CustomStore({
			key: 'id',
			async load({ skip, take }) {
				let response;

				if (selectedProcess.projectPlatform === ProjectPlatform.Synergy) {
					response = await getProcessesDetailsPromise({
						process: selectedProcess,
						skip,
						take,
						category
					});
				} else if (selectedProcess.projectPlatform === ProjectPlatform.eBA) {
					response = await geteBAProcessesDetailsPromise({
						process: selectedProcess,
						skip,
						take
					});
				}

				if (response) {
					if (previousProcessId != selectedProcess.id) {
						setStructure(response.columns.filter(c => c.name !== 'Events'));
					}

					if (resetScrollRef.current) {
						setTimeout(() => {
							try {
								bcDataGridRef.current
									?.instance()
									.getScrollable()
									?.scrollTo({ left: 0, top: 0 });
							} catch (e) {
								console.error(e);
							}
						}, 100);

						resetScrollRef.current = false;
					}

					return response.data;
				}

				return [];
			}
		});
	}, [selectedProcess?.id]);
	return { dataSource, structure };
};

export default useProcessDataSource;
